import React, { useEffect, useState, useMemo } from "react";
import NoDataFound from "../common/NoDataFound";
import SummaryBox from "./SummaryBox";
import { loadStyles } from "../../utils/cssLoader";
import { getRugbyHalves } from "../../utils/rugbyUtils";

const RugbyInfo = ({
  ServerData,
  dictionary = {},
  loadCSS = true,
  dataClient = false,
  title,
  baseUrl,
}) => {
  const [clientData, setClientData] = useState(null);
  const data = useMemo(
    () => (dataClient ? clientData : ServerData),
    [clientData, ServerData, dataClient]
  );

  useEffect(() => {
    if (!dataClient) return;

    try {
      const raw = document
        ?.querySelector(".microservice-cont")
        ?.getAttribute("data-listingdata");
      if (!raw) return;

      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed ?? null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("rugby");
    }
  }, [loadCSS]);
  const halves = getRugbyHalves(data);

  return (
    <>
      {title && <h1>{title}</h1>}

      <div className="rugby_summary">
        {data ? (
          halves?.map((half, index) => (
            <React.Fragment key={index}>
              <SummaryBox
                key={half?.title}
                title={half?.title}
                score={half?.score}
                data={half?.events}
              />
            </React.Fragment>
          ))
        ) : (
          <NoDataFound />
        )}
      </div>
    </>
  );
};

export default RugbyInfo;
